import { ModuleId } from "flavr-common";
export const INTERACTION_HANDLER_PREFIX = "InteractionHandler";
export function isMessageFromModule(meta, moduleId) {
    return meta.source.moduleId === moduleId;
}
export function isSessionMessage(meta) {
    return isMessageFromModule(meta, ModuleId.SERVER_CONNECTION) || isMessageFromModule(meta, ModuleId.SESSION) || isMessageFromModule(meta, ModuleId.PEER);
}
export function isScriptMessage(meta) {
    return meta.source.moduleId.startsWith("ScriptModule");
}
export function isInteractionMessage(meta) {
    return meta.source.moduleId.startsWith(INTERACTION_HANDLER_PREFIX);
}
